import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Popover,
  Button,
  Grow,
} from "@mui/material";
import { InfoRounded } from "@mui/icons-material";
import { TripDetails } from "../../../types/api";
import { BusinessProfile } from "../../../types/profile";
import { chipsDetails } from "../style";
import { useTranslation } from "react-i18next";

interface ChipsDetailsProps {
  tripDetails: TripDetails;
  businessProfile?: BusinessProfile;
  firstDriver:any
}

const ChipsDetails: React.FC<ChipsDetailsProps> = ({
  tripDetails,
  businessProfile,
  firstDriver
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [popoverContent, setPopoverContent] = useState<JSX.Element | null>(
    null
  );
  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement>,
    content: string
  ) => {
    setAnchorEl(event.currentTarget);

    // Mostra contenuti differenti in base al pulsante cliccato
    if (content === "PLANNER") {
      setPopoverContent(
        <Box>
          <Typography sx={chipsDetails.titlePopOver}>
            {" "}
            {t("screens.trips.chips.planner")}
          </Typography>
          <Typography sx={chipsDetails.subTitlePopOver}>
            {tripDetails.dispatcherName ? tripDetails.dispatcherName : "-"}
          </Typography>

          <Typography sx={chipsDetails.titlePopOver}>
            {t("screens.trips.chips.email")}
          </Typography>
          <Typography
          
            
            sx={chipsDetails.buttonPopOver}
          >
            {tripDetails.dispatcherMail ? tripDetails.dispatcherMail : "-"}
          </Typography>

          <Typography sx={chipsDetails.titlePopOver}>
            {t("screens.trips.chips.phone")}
          </Typography>
          {tripDetails.dispatcherPhone ? (
            <Typography
             
              sx={chipsDetails.buttonPopOver}
            >
              {tripDetails.dispatcherPhone}
            </Typography>
          ) : (
            "-"
          )}
        </Box>
      );
    } else if (content === "TP SPECIALIST") {
      setPopoverContent(
        <Box>
          <Typography sx={chipsDetails.titlePopOver}>
            {t("screens.trips.chips.tpSpecialist")}
          </Typography>
          <Typography sx={chipsDetails.subTitlePopOver}>
          {businessProfile?.tpspecialists[0].firstname + " " +businessProfile?.tpspecialists[0].lastname || "-"  }
          </Typography>

          <Typography sx={chipsDetails.titlePopOver}>
            {t("screens.trips.chips.email")}
          </Typography>
          <Typography 
          
            sx={chipsDetails.buttonPopOver}
          >
             {businessProfile?.tpspecialists[0].mail || "-" }
          </Typography>

          <Typography sx={chipsDetails.titlePopOver}>
            {t("screens.trips.chips.phone")}
          </Typography>
          {businessProfile?.tpspecialists[0].mobilephone ? (
            <Typography 
             
              sx={chipsDetails.buttonPopOver}
            >
              {businessProfile.tpspecialists[0].mobilephone}
            </Typography>
          ) : (
            "-"
          )}
        </Box>
      );
    } else if (content === "DRIVER") {
      setPopoverContent(
        <Box>
          <Typography sx={chipsDetails.titlePopOver}>
          {t("screens.trips.chips.firstDriver")}
          </Typography>
          <Typography sx={chipsDetails.subTitlePopOver}>
              {/*DA RIMUOVERE DOPO PROD TECNICO* */}
              {(firstDriver && firstDriver.data)? (firstDriver.data.firstName + " "+ firstDriver.data.lastName):"-" } 
          
          </Typography>

          <Typography sx={chipsDetails.titlePopOver}>
            {t("screens.trips.chips.email")}
          </Typography>
          <Typography
         
           
            sx={chipsDetails.buttonPopOver}
          >
            {(firstDriver && firstDriver.data)? firstDriver.data.email:"-" }
          </Typography>

          <Typography sx={chipsDetails.titlePopOver}>
            {t("screens.trips.chips.phone")}
          </Typography>
          {(firstDriver && firstDriver.data)? (
            <Typography
             
             
              sx={chipsDetails.buttonPopOver}
            >
               {(firstDriver && firstDriver.data)? firstDriver.data.phone:"-" }
            </Typography>
          ) : (
            "-"
          )}
        </Box>
      );}
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverContent(null);
  };

  const isPopoverOpen = Boolean(anchorEl);
  const[isDriverMissing,setIsDriverMissing] = useState<boolean>(!firstDriver?.data?.firstName || ["", "-"].includes(firstDriver.data.firstName.trim()))
  useEffect(()=>{
    setIsDriverMissing(!firstDriver?.data?.firstName || ["", "-"].includes(firstDriver.data.firstName.trim()))
  },[firstDriver,isDriverMissing])
  return (
    <Box sx={chipsDetails.mainWrapper}>
      {/* First Driver */}
      <Box sx={chipsDetails.wrapper}>
      <Box>
        <Typography sx={chipsDetails.title}>
          {t("screens.trips.chips.firstDriver")}
        </Typography>
        <Typography sx={chipsDetails.subTitle}>
          {/*DA RIMUOVERE DOPO PROD TECNICO* */}
              {(firstDriver && firstDriver.data)? (firstDriver.data.firstName + " "+ firstDriver.data.lastName):"-" } 
     
        </Typography>
        </Box>
        <IconButton
        disabled={isDriverMissing}
          sx={chipsDetails.iconButton}
          onClick={(e) => handlePopoverOpen(e, "DRIVER")}
        >
          <InfoRounded  sx={{...chipsDetails.icon,color:!isDriverMissing? 'primary.main':'gray'}} />
        </IconButton>
      </Box>

      {/* Dispatcher */}
      <Box sx={chipsDetails.wrapper}>
        <Box>
          <Typography sx={chipsDetails.title}>
            {t("screens.trips.chips.planner")}
          </Typography>
          <Typography sx={chipsDetails.subTitle}>
            {tripDetails.dispatcherName}
          </Typography>
        </Box>
        <IconButton
          sx={chipsDetails.iconButton}
          onClick={(e) => handlePopoverOpen(e, "PLANNER")}
        >
          <InfoRounded color="primary" sx={chipsDetails.icon} />
        </IconButton>
      </Box>

      {/* TP Specialist */}
      <Box sx={chipsDetails.wrapper}>
        <Box>
          <Typography sx={chipsDetails.title}>
            {t("screens.trips.chips.tpSpecialist")}
          </Typography>
          <Typography sx={chipsDetails.subTitle}>
            {businessProfile?.tpspecialists[0].firstname + " " +businessProfile?.tpspecialists[0].lastname  }
          </Typography>
        </Box>
        <IconButton
          sx={chipsDetails.iconButton}
          onClick={(e) => handlePopoverOpen(e, "TP SPECIALIST")}
        >
          <InfoRounded color="primary" sx={chipsDetails.icon} />
        </IconButton>
      </Box>

      {/* Popover */}
      <Popover
        sx={chipsDetails.popOver}
        open={isPopoverOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        TransitionComponent={Grow} // Aggiunge una transizione fluida
        TransitionProps={{ timeout: 0 }} // Durata dell'animazione in ms
      >
        <Box sx={chipsDetails.popOverBox}>{popoverContent}</Box>
      </Popover>
    </Box>
  );
};

export default ChipsDetails;
